import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Helper } from 'src/app/helper/defult';
import { HttpIOService } from 'src/app/services/http-io.service';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { PopupConfirmationComponent } from 'src/app/container/elements/popup-confirmation/popup-confirmation.component';
import { DynamicSnacbarErrorComponent } from 'src/app/container/elements/dynamic-snacbar-error/dynamic-snacbar-error.component';
import { EmployerService } from 'src/app/services/employer.service';
import { DynamicSnacbarComponent } from 'src/app/container/elements/dynamic-snacbar/dynamic-snacbar.component';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-cv-review-landing',
  templateUrl: './cv-review-landing.component.html',
  styleUrls: ['./cv-review-landing.component.scss'],
})
export class CvReviewLandingComponent implements OnInit {
  showForm: boolean = false;
  showSuccess: boolean = false;
  showATS: boolean = false;
  selectedOption = 'haveCV';
  showCVUpload: boolean = false;
  selectedFile: File | null = null;
  // Takes the file added as input and uploads it
  file: { name: string; progress: number; file: File; size: number } | null =
    null;
  fileToUpload = [];
  emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9_.+-]{2,}$/;
  numberPattern = /^\+?\d+$/;
  namePattern = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
  withCVForm: FormGroup;
  withoutCVForm: FormGroup;
  geminiSuggestions: any = null;
  geminiRefinedCV: any = null;
  isLoggedIn: boolean = false;

  list_benefits = [
    {
      photo: '../../../../assets/images/paper-emoji.webp',
      text: 'Personalized Feedback',
    },
    {
      photo: '../../../../assets/images/rocket-emoji.webp',
      text: 'ATS Optimization',
    },
    {
      photo: '../../../../assets/images/target-emoji.webp',
      text: 'Job Matching Insight',
    },
  ];

  feedback_card = [
    {
      text: 'I got 3 interviews within two weeks of updating my CV using their suggestions. Totally worth it!”',
      naam: 'James Faleke',
      company: 'Senior Marketing Specialist',
    },
    {
      text: 'Their insights completely changed how I presented my experience. I finally got noticed!”',
      naam: 'Abdul Rahman Malik',
      company: 'Senior Software Engineer',
    },
  ];

  expLvl = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
  ];

  education = [
    'Masters Degree (M.Sc)',
    'Bachelors Degree (B.Sc/B.tech/B.Ed)',
    'Higher National Diploma (HND)',
    'Ordinary National Diploma (HND)',
    'Secondary School certificate (SSCE)',
  ];

  constructor(
    private fb: FormBuilder,
    private helper: Helper,
    private empService: EmployerService,
    private snackBar: MatSnackBar,
    private io: HttpIOService,
    private dialog: MatDialog,
    private router: Router,
    private auth: AuthService
  ) {
    const state = history.state;
    this.isLoggedIn = this.auth.isLoggedIn();

    if (state && state.showATS) {
      this.geminiSuggestions = state.geminiSuggestions;
      this.geminiRefinedCV = state.geminiRefinedCV;
      this.showATS = true;
      this.showForm = false;
      this.showSuccess = false;
    }
  }

  ngOnInit(): void {
    if (!this.showATS) {
      this.validationForm();
      this.validationForm2();
    }
  }

  get f() {
    return this.withCVForm.controls;
  }

  get f2() {
    return this.withoutCVForm.controls;
  }

  validationForm() {
    this.withCVForm = this.fb.group({
      phoneNumber: [
        '',
        [Validators.required, Validators.pattern(this.numberPattern)],
      ],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      // file: ['', Validators.required],
    });
  }

  validationForm2() {
    this.withoutCVForm = this.fb.group({
      fullName: [
        '',
        [Validators.required, Validators.pattern(this.namePattern)],
      ],
      phoneNumber: [
        '',
        [Validators.required, Validators.pattern(this.numberPattern)],
      ],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      experience: ['', Validators.required],
      education: ['', Validators.required],
    });
  }

  extractFirstLetter(text: string): string {
    // Common titles or prefixes to ignore
    const ignoreWords = ['mr', 'mrs', 'ms', 'miss', 'dr', 'head', 'of', 'hr'];

    // Split text by spaces
    const words = text.trim().split(/\s+/);

    // Find the first word that is not a title
    const name = words.find(
      (word) => !ignoreWords.includes(word.toLowerCase())
    );

    // Return the first letter of that name (uppercase)
    return name ? name[0].toUpperCase() : '';
  }

  toggleFormUI() {
    this.showForm = !this.showForm;
  }

  // Takes the file added as input and uploads it
  onFileSelected(event: any): void {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      this.file = {
        name: selectedFile.name,
        progress: 0,
        file: selectedFile,
        size: selectedFile.size,
      };
      this.uploadFile();
    }
  }

  // To trigger the progress bar on file upload
  uploadFile(): void {
    const interval = setInterval(() => {
      if (this.file) {
        this.file.progress += 10;
        if (this.file.progress >= 100) {
          clearInterval(interval);
        }
      }
    }, 1000);
  }

  removeFile(): void {
    if (this.file) {
      this.file.progress = 0;
      this.file.name = '';
      this.file.size = 0;
      this.file.file = null as any;
    }
    console.log('file: ', this.file);
    this.file = null;
  }

  async submitCV() {
    if (this.withCVForm.status === 'INVALID') {
      this.helper.markFormGroupTouched(this.withCVForm);
      return false;
    } else {
      const formData = new FormData();
      formData.append('path', 'upload-file');
      formData.append('purpose', 'cvReview');
      formData.append('file', this.file.file);
      await this.io._uploadFile(formData).subscribe(
        (res: any) => {
          this.fileToUpload.push(
            res['result'].id + '_' + res['result'].fileName
          );
          // Takes the CV and parse it
          // let payLoad = {
          //   email: this.withCVForm.value.email,
          //   phoneNumber: this.withCVForm.value.phoneNumber,
          //   path: '/add-training-user-info',
          //   category: 'hasResume',
          //   file: this.fileToUpload.map(file => ({
          //     Key: file,
          //   })),
          // }
          let payLoad = {
            path: '/cv-review',
            email: this.withCVForm.value.email,
            phoneNumber: this.withCVForm.value.phoneNumber,
            file: this.fileToUpload.map((file) => ({
              Key: file,
            })),
          };
          this.io._getCvFeedback(payLoad).subscribe((res: any) => {
            if (res.serverResponse.code == 200) {
              // this.showSuccess = true;
              this.showATS = true;
              this.geminiSuggestions = res.result.points;
              this.geminiRefinedCV = res.result.resumedata;
              this.showForm = false;
              this.file = null;
              this.fileToUpload = [];
              this.withCVForm.reset();
            } else {
              this.snackBar
                .openFromComponent(DynamicSnacbarErrorComponent, {
                  data: res.body,
                  verticalPosition: 'top', // 'top' | 'bottom'
                  horizontalPosition: 'right', //'start' | 'center' | 'end' | 'left' | 'right'
                  duration: 6000,
                })
                .afterOpened()
                .subscribe(this.helper.setOnTop);
            }
          });
        },
        (err) => console.log(err)
      );
    }
  }

  async withoutCV() {
    if (this.withoutCVForm.status === 'INVALID') {
      this.helper.markFormGroupTouched(this.withoutCVForm);
      return false;
    } else {
      let payLoad = {
        fullName: this.withoutCVForm.value.firstName,
        email: this.withoutCVForm.value.email,
        phoneNumber: this.withoutCVForm.value.phoneNumber,
        experience: this.withoutCVForm.value.experience,
        education: this.withoutCVForm.value.education,
        path: '/add-training-user-info',
        category: 'hasNotResume',
      };
      this.io._saveUserData(payLoad).subscribe((res: any) => {
        if (res.serverResponse.code == 200) {
          this.showSuccess = true;
          this.showForm = false;
          this.withoutCVForm.reset();
        } else {
          this.snackBar
            .openFromComponent(DynamicSnacbarErrorComponent, {
              data: res.body,
              verticalPosition: 'top', // 'top' | 'bottom'
              horizontalPosition: 'right', //'start' | 'center' | 'end' | 'left' | 'right'
              duration: 6000,
            })
            .afterOpened()
            .subscribe(this.helper.setOnTop);
        }
      });
    }
    (err) => console.log(err);
  }

  withoutCVLogin() {
    if (!this.auth.isLoggedIn()) {
      this.router.navigate(['/login']);
    } else {
      this.router.navigate(['/jobseeker-profile']);
    }

    localStorage.setItem('redirectTo', '/jobseeker-profile');
  }

  withoutCVSignUp() {
    if (!this.auth.isLoggedIn()) {
      this.router.navigate(['/signup']);
    } else {
      this.router.navigate(['/jobseeker-profile']);
    }

    localStorage.setItem('redirectTo', '/jobseeker-profile');
  }

  goToCVoption() {
    this.showSuccess = false;
    this.showATS = false;
    this.showForm = true;
    this.selectedOption = 'haveCV';
  }

  continueToCVBuilder() {
    this.router.navigate(['/jobseeker-profile']);
  }

  goToCvSeletor() {
    this.router.navigate(['/cv-review/cv-selector'], {
      state: { resumeData: this.geminiRefinedCV },
    });
  }
}
